import Icon from "./Icon";
import AttendanceWidget from "./attendance/AttendanceWidget";

export default function Topbar({
  title,
  crumbs,
  actions,
  onCmdK,
  onLogout,
  onAccount,
  unreadCount = 0,
  onOpenNotifications,
  onOpenChat,
  chatUnread = 0,
  attendanceEnabled = false,
  onOpenMobileMenu,
}) {
  return (
    <header className="topbar">
      {onOpenMobileMenu && (
        <button
          type="button"
          className="mobile-menu-btn"
          onClick={onOpenMobileMenu}
          aria-label="Open menu"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
      )}
      <div>
        <div className="topbar-title">{title}</div>
        {crumbs && (
          <div className="topbar-crumbs">
            {crumbs.map((c, i) => (
              <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                {i > 0 && <span className="sep">/</span>}
                <span>{c}</span>
              </span>
            ))}
          </div>
        )}
      </div>
      <div className="topbar-search">
        <div className="search-input-wrap" onClick={onCmdK} role="button" tabIndex={0}>
          <Icon name="search" size={14} />
          <input className="search-input" placeholder="Search…" readOnly />
          <kbd>⌘K</kbd>
        </div>
      </div>
      <div className="topbar-actions">
        {actions}
        {attendanceEnabled && <AttendanceWidget />}
        {onOpenChat && (
          <button className="icon-btn" title="Chat" onClick={onOpenChat}>
            <Icon name="message-circle" size={16} />
            {chatUnread > 0 && <span className="dot" />}
          </button>
        )}
        <button
          className="icon-btn"
          title="Notifications"
          onClick={onOpenNotifications}
        >
          <Icon name="bell" size={16} />
          {unreadCount > 0 && <span className="dot" />}
        </button>
        {onAccount && (
          <button className="icon-btn" onClick={onAccount} title="My account">
            <Icon name="user" size={16} />
          </button>
        )}
        <button className="icon-btn" onClick={onLogout} title="Sign out">
          <Icon name="log-out" size={16} />
        </button>
      </div>
    </header>
  );
}
